import { gql, useQuery } from "@apollo/client";
import { getFetchPolicyOptions } from "api/utils";
import { CapguardPollDataQuery } from "./types";

export const POLL_DATA = gql`
  query GetCapguardPollData {
    security(id: 2128232) {
      id
      figuresAsObject {
        figures
      }
    }
  }
`;

export const useGetCapguardPollData = () => {
  const { loading, error, data, refetch } = useQuery<CapguardPollDataQuery>(
    POLL_DATA,
    {
      ...getFetchPolicyOptions(`useGetCapguardPollData`),
    }
  );

  return {
    loading: loading,
    error: error,
    data: data,
    refetch,
  };
};
